const styles = (theme) => ({
  content: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(2.5),
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent',
    },
  },
  grey: {
    background: theme.color.grey_mist,
  },
  scrollArea: {
    height: 'calc(100% - 60px)',
  },
  scrollAreaWithTabs: {
    height: 'calc(100% - 100px)',
  },
  scrollAreaWithHeaderAndDrawer: {
    height: 'calc(100% - 140px)',
  },
  scrollAreaWithChips: {
    overflow: 'hidden',
  },
});

export default styles;
